import React, { useState } from 'react';

import Box from '@amzn/meridian/box';
import BreadCrumbs from 'src/components/shared/breadcrumbs/breadcrumbs';

import './jobConfiguration.scss';

import JobConfigurationPanel from './jobConfigurationPanel/jobConfigurationPanel';
import TabGroupWrapper from './tabGroupWrapper/tabGroupWrapper';

const JobConfiguration = () => {
  const [currentTab, setCurrentTab] = useState('job-config');

  return (
    <div className="job-configuration">
      <BreadCrumbs
        breadcrumbList={[
          { label: 'Return To Work 2.0', url: '/' },
          { label: 'Job Configuration Portal', url: '/adminConfiguration' },
        ]}
      />

      <div className="job-configuration__tab-group">
        <TabGroupWrapper currentTab={currentTab} setCurrentTab={setCurrentTab} />
      </div>

      <Box type="outline" spacingInset="200 500 400 500" className="job-configuration__content">
        {currentTab === 'job-config' && <JobConfigurationPanel />}
      </Box>
    </div>
  );
};

export default JobConfiguration;
